import { GrowthBook } from "@growthbook/growthbook-react";
import {growthbookAPIHost, growthbookClientKey} from "../config/constants";

const gb = new GrowthBook({
  apiHost: growthbookAPIHost,
  clientKey: growthbookClientKey,
  enableDevMode: process.env.NODE_ENV !== "production",
  subscribeToChanges: true
});

export default gb;
